import React, { useContext, useState, useEffect } from 'react';
import { PersistGate } from 'redux-persist/es/integration/react';
import './App.scss';
import { Provider } from 'react-redux';
import store, { persistor } from './store';
import AppRoutes from './routes';
import { Theme, themeContext as ThemeContext } from './Context';
import KYCRegisterPopup from './components/common/KYCRegisterPopup';

export default function App() {
    const { theme } = useContext(ThemeContext);
    const [_theme, _updateTheme] = useState<Theme>(theme);

    useEffect(() => {
        const cordovaPath = process.env.REACT_APP_CORDOVA_PATH;
        if (cordovaPath) {
            (function (d, s, id) {
                let js: any;
                let stags: any = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.id = id;
                js.src = `/${cordovaPath}`;
                stags.parentNode.insertBefore(js, stags);
            })(document, 'script', 'cordova');
        }
    }, []);

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <ThemeContext.Provider value={{ theme: _theme, updateTheme: _updateTheme }}>
                    <div>
                        <KYCRegisterPopup />
                        <main id="main-content">
                            <AppRoutes />
                        </main>
                    </div>
                </ThemeContext.Provider>
            </PersistGate>
        </Provider>
    );
}
